/**
 * Created by zzy on 2019/8/5.
 */
import PersonalAccessRecords from './PersonalAccessRecords.vue'
export default PersonalAccessRecords



// WEBPACK FOOTER //
// ./src/views/events/PersonalAccessRecords/index.js